import {
  AccountCircleIcon,
  BusinessIcon,
  DatabaseIcon,
  InfoIcon,
  PeopleIcon,
  ProfileIcon,
  SearchIcon,
  WbShadeIcon,
} from '@medeloop/medeloop-components-library';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Outlet } from 'react-router-dom';
import { SubMenu } from 'src/components/sub-menu/sub-menu';

const accountItems = [
  {
    name: 'About',
    link: '/account/about',
    icon: <InfoIcon className="w-5 h-5" />,
    hidden: false,
  },
  {
    name: 'Profile',
    link: '/account/profile',
    icon: <AccountCircleIcon className="w-5 h-5" />,
    hidden: false,
  },
  {
    name: 'Organizations',
    link: '/account/organizations',
    icon: <BusinessIcon className="w-5 h-5" />,
    hidden: true,
  },
  {
    name: 'Organizational Units',
    link: '/account/organizational-units',
    icon: <WbShadeIcon className="w-5 h-5" />,
    hidden: true,
  },
  {
    name: 'Studies',
    link: '/account/studies',
    icon: <PeopleIcon className="w-5 h-5" />,
    hidden: false,
  },
  {
    name: 'Data',
    icon: <DatabaseIcon className="w-5 h-5" />,
    link: '/account/data/datasets',
    hidden: false,
  },
];

const administrationItems = [
  {
    name: 'Members',
    icon: <ProfileIcon className="w-5 h-5" />,
    link: '/administration/members',
  },
  {
    name: 'Usage & metrics',
    icon: <SearchIcon className="w-5 h-5" />,
    link: '/administration/usage-and-metrics',
  },
];

export function SideBar() {
  const { launchAccountMenu } = useFlags();

  return (
    <main className="w-screen h-[calc(100vh-56px)] flex">
      {/* Sidebar area */}
      <aside className="min-w-[253px] bg-dark-subdued-background border-r border-stroke-on-dark-subdued py-6 px-4">
        <SubMenu title="Account" items={accountItems} />
        {!launchAccountMenu && <SubMenu title="Administration" items={administrationItems} />}
      </aside>
      {/* Main content area */}
      <div className="w-full overflow-auto bg-background-dark-default text-content-on-dark-subdued">
        <Outlet />
      </div>
    </main>
  );
}
